"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignmentBasicInfo = void 0;
const lodash_1 = require("lodash");
const AssignmentUtils_1 = require("./AssignmentUtils");
var AssignmentBasicInfo;
(function (AssignmentBasicInfo) {
    function create(content) {
        return {
            name: content.name,
            message: content.message,
            subject: content.subject,
            pin: AssignmentUtils_1.AssignmentUtils.firstPin(content),
            numberOfPins: (0, lodash_1.size)(AssignmentUtils_1.AssignmentUtils.pinsByAssignmentType(content)),
            ownerId: content.ownerId,
        };
    }
    AssignmentBasicInfo.create = create;
})(AssignmentBasicInfo || (exports.AssignmentBasicInfo = AssignmentBasicInfo = {}));
//# sourceMappingURL=AssignmentBasicInfo.js.map